<template>
  <div>
    <Card>
      <Row>
        <!-- <Button type="info"
                @click="add">新增</Button> -->
      </Row>
      <TablePaginate :columns="columns"
                     :data="deduct_coupons"
                     :loading="loading"
                     :meta="meta"
                     :changePage="changePage"></TablePaginate>
    </Card>
    <Modal v-model="modalShow"
           @on-ok="handleSubmit"
           :title="$t('pages_deduct_coupon_index_429')">
      <Form ref="category"
            :model="deduct_coupon"
            :label-width="80">
        <Form-item :label="$t('pages_deduct_coupon_index_430')"
                   prop="name">
          <Input type="text"
                 v-model="deduct_coupon.name" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_431')"
                   prop="deduct_category_type">
          <Select label-in-value
                  v-model="deduct_coupon.deduct_category_type">
            <Option v-for="item in deduct_category_types"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_432')"
                   prop="deduct_category_id">
          <Input type="text" number
                 v-model="deduct_coupon.deduct_category_id" />
        </Form-item>
         <Form-item :label="$t('pages_deduct_coupon_index_433')"
                   prop="deduct_category_name">
          <!-- <Select label-in-value
                  v-model="deduct_coupon.deduct_category_name">
            <Option v-for="item in deduct_category_names"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select> -->
          <Input type="text" disabled
                 v-model="deduct_coupon.deduct_category_name" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_434')"
                   prop="use_it_minimum_consumption">
          <Input type="text" number
                 v-model="deduct_coupon.use_it_minimum_consumption" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_435')"
                   prop="fetch_it_minimum_consumption">
          <Input type="text" number
                 v-model="deduct_coupon.fetch_it_minimum_consumption" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_436')"
                   prop="price">
          <Input type="text" number
                 v-model="deduct_coupon.price" />
        </Form-item>
        <Form-item :label="$t('pages_bookings_detail_223')"
                   prop="quantity">
          <Input type="text" number
                 v-model="deduct_coupon.quantity" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_437')"
                   prop="expired_date_category">
          <Select label-in-value
                  v-model="deduct_coupon.expired_date_category">
            <Option v-for="item in expired_date_categorys"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_438')"
                   prop="expired_date">
          <Input type="text"
                 v-model="deduct_coupon.expired_date" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_439')"
                   prop="expired_on_received_some_days">
          <Input type="text" number
                 v-model="deduct_coupon.expired_on_received_some_days" />
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_440')"
                   prop="effective_date_category">
          <Select label-in-value
                  v-model="deduct_coupon.effective_date_category">
            <Option v-for="item in effective_date_categorys"
                    :value="item.value"
                    :key="item.value">{{ item.name }}</Option>
          </Select>
        </Form-item>
        <Form-item :label="$t('pages_deduct_coupon_index_441')"
                   prop="effective_date">
          <Input type="text"
                 v-model="deduct_coupon.effective_date" />
        </Form-item>
         <Form-item :label="$t('pages_balance_transaction_index_176')"
                   prop="is_running">
          <i-switch v-model="deduct_coupon.is_running" size="large">
            <span slot="open">{{$t('pages_birthday_discount_index_208')}}</span>
            <span slot="close">{{$t('pages_birthday_discount_index_209')}}</span>
          </i-switch>
        </Form-item>
      </Form>
    </Modal>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapState, mapActions, mapMutations } from 'vuex'
import TablePaginate from '@/components/TablePaginate'
import { formatDateTime } from '@/libs/table-render'

export default {
  components: {
    TablePaginate,
  },
  data () {
    const that = this;
    return {
      modalShow: false,
      formType: '',
      columns: [
        {
          title: i18n.t('pages_deduct_coupon_index_442'),
          key: 'fresh_customer_id',
        },
        {
          title: i18n.t('pages_deduct_coupon_index_430'),
          key: 'deduct_category_name',
        },
        {
          title: i18n.t('pages_deduct_coupon_index_431'),
          key: 'deduct_category_type',
          width: 100,
          render: (h, params) => {
            return h('span', that.getSelectName('deduct_category_type', params.row.deduct_category_type))
          }
        },
        {
          title: i18n.t('pages_deduct_coupon_index_443'),
          key: 'use_it_minimum_consumption',
          width: 140,
        },
        {
          title: i18n.t('pages_deduct_coupon_index_436'),
          key: 'price',
          width: 100,
        },
        {
          title: i18n.t('pages_deduct_coupon_index_444'),
          key: 'effective_date',
          render: (h, params) => {
            return formatDateTime(h, params.row.effective_date)
          }
        },
        {
          title: i18n.t('pages_deduct_coupon_index_445'),
          key: 'expired_date',
          render: (h, params) => {
            return formatDateTime(h, params.row.expired_date)
          }
        },
        // {
        //   title: '操作',
        //   key: 'action',
        //   width: 300,
        //   align: 'center',
        //   fixed: 'right',
        //   render: (h, params) => {
        //     const children = []
        //     children.push(editorButtonInTable(this, h, params))
        //     return h('div', children)
        //   }
        // }
      ],
      deduct_category_types: [
        { name: i18n.t('pages_deduct_coupon_index_446'), value: 'shop' },
        { name: i18n.t('pages_booking_store_products_index_213'), value: 'fresh_category' },
        { name: i18n.t('pages_deduct_coupon_index_447'), value: 'fresh_product' },
      ],
    }
  },
  created () {
    this.changeQuery({ page: 1 })
    this.index()
  },
  computed: {
    ...mapState('deduct_coupon', ['deduct_coupon', 'deduct_coupons', 'meta', 'loading']),
  },
  methods: {
    ...mapActions('deduct_coupon', [
      'clear',
      'index',
      'show',
      'create',
      'update',
      'destroy'
    ]),
    ...mapMutations('deduct_coupon', ['changeQuery']),
    getSelectName (type, value) {
      const result = this[`${type}s`].find(item => item.value === value)
      return result.name
    },
    changePage (page) {
      this.changeQuery({ page: page })
      this.index()
    },
    add () {
      this.clear()
      this.modalShow = true
      this.formType = 'new'
    },
    async handleSubmit () {
      if (this.formType === 'edit') {
        await this.update(this.deduct_coupon)
      } else if (this.formType === 'new') {
        await this.create(this.deduct_coupon)
      }
      this.modalShow = false
    },
    change_deduct_coupon_auto_upgrade () {
      this.upgrade({ deduct_coupon_auto_upgrade: this.setting.deduct_coupon_auto_upgrade })
    },
  }
}
</script>
